import React, { useEffect, useState } from 'react'
import { useWatch } from 'react-hook-form'
import { Form, Alert } from 'react-bootstrap'
import { connect } from "react-redux"
import { getAllPeriods } from '../../../redux/actions/periodActions'

import './PeriodNameErrors.css'

const PeriodNameErrors = ({ control, yearError, halfError, nameError, setError, clearErrors, existing, selected, getAllPeriods }) => {
    const year = useWatch({
      control, name: 'year', defaultValue: ''
    })
    const half = useWatch({
      control, name: 'half', defaultValue: ''
    })

    const [yearPattern] = useState(RegExp(/\d{4}/));

    useEffect( () => {
        !existing.length && getAllPeriods()
    }, [])
    
    /**
     * Perform real-time validation over the period's *year* and *half* fields.
     */
    useEffect(() => {
        clearErrors(['name', 'year', 'half'])

        if (yearPattern.test(year) === false) return setError('year', { message: "Año inválido." });
  
        if (existing.filter(p => p.nombre !== selected.info?.nombre).find(p => p.year == year && p.half == half) !== undefined) {
            setError('name', { message: "El periodo ya está registrado." })
        }
        
    }, [year, half, existing.length, selected.info?.nombre])

  
    return (
        <Form.Row className="justify-content-center">
            <Alert variant={!!nameError ? 'danger' : 'transparent'}>{nameError?.message} </Alert>
            <Alert variant={!!yearError ? 'danger' : 'transparent'}>{yearError?.message} </Alert>
            <Alert variant={!!halfError ? 'danger' : 'transparent'}>{halfError?.message} </Alert>
        </Form.Row>
    )
}

const mapStateToProps = ({ periodsReducer, selectedPeriodInfo }) => ({
  existing: periodsReducer,
  selected: selectedPeriodInfo
})

export default connect(mapStateToProps, {getAllPeriods})(PeriodNameErrors)